export default {
  facilities: state => state.facilities,
  facility: state => state.facility,

  loading: state => state.loading,
  error: state => state.error,
  message: state => state.message,

  // filters & pagination
  filters: state => state.filters,
  pagination: state => state.pagination,

  isEmpty: state => state.users.length === 0
}